import styles from "./style";
import { useEffect, useState } from "react";
import { Routes, Route, BrowserRouter, useLocation, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Contact from "./pages/Contact";
import Expertise from "./pages/Expertise";
import Products from "./pages/Products";
import Company from "./pages/Company";
import Navbar from "./components/Navbar";
import Blog from "./pages/Blog";
import Loader from "./components/Loader";
import { AnimatePresence } from "framer-motion";
import ProductDetail from "./pages/components/ProductDetail";
import BlogDetail from "./components/BlogDetail";
import BlogList from "./components/BlogList";
import Login from "./components/user/login";
import BlogWrite from "./components/BlogWrite";
import { ceo, contact, contact1, contact2, contact3, contact4, LogoIcon, LogoName1, s1, s10, s11, s2, s3, s4, s5, s6, s7, s8, s9 } from "./assets";
import { preloadImages } from "./utils/imagePreloader";

// Protected Route Component
const ProtectedRoute = ({ children, requireAdmin }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  const isAdmin = localStorage.getItem('isAdmin') === 'true';
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/blog" replace />;
  }
  
  return children;
};

function AnimatedRoutes() {
  const location = useLocation()

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/Expertise" element={<Expertise />} />
        <Route path="/Product" element={<Products />} />
        <Route path="/Company" element={<Company />} />
        <Route path="/Blog" element={<Blog />} />
        <Route path="/BlogDetail/:id" element={<BlogDetail />} />
        <Route path="/BlogWrite" element={<BlogWrite />} />
        <Route path="/Contact" element={<Contact />} /> 
        <Route path="/Product" element={<ProductDetail />} />
        <Route path="/Login" element={<Login />} />
        
        {/* Protected Admin Route - Blog Dashboard */}
        <Route 
          path="/BlogWrite" 
          element={
            <ProtectedRoute requireAdmin={true}>
              <BlogWrite />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </AnimatePresence>
  )
}

function App() {
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
   // Collect ALL images used throughout your application
    const imagesToPreload = [ 
      LogoIcon,
      LogoName1,
      contact,
      contact1,
      contact2,
      contact3,
      contact4,
      s1,
      s2,
      s3,
      s4,
      s5,
      s6,
      s7,
      s8,
      s9,
      s10,
      s11,
      ceo,
    ].filter(Boolean);

  const loadAllImages = async () => {
      try {
        console.log(`Starting to preload ${imagesToPreload.length} images...`);
        
        // Minimum loading time for smooth transition (2 seconds)
        const minLoadTime = 2000;
        const startTime = Date.now();

        await preloadImages(imagesToPreload, (progress) => {
          setLoadingProgress(progress);
        });

        // Ensure minimum loading time for smooth UX
        const elapsed = Date.now() - startTime;
        if (elapsed < minLoadTime) {
          await new Promise(resolve => setTimeout(resolve, minLoadTime - elapsed));
        }

        console.log('All images preloaded successfully!');
        
        // Smooth transition
        setShowContent(true);
        
        // Remove loader after transition
        setTimeout(() => {
          setIsLoading(false);
        }, 600);

      } catch (error) {
        console.error("Image preloading failed:", error);
        // Still show content even if preloading fails
        setShowContent(true);
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      }
  };

    loadAllImages();
  }, []);

  // Show loader while images are being preloaded
  if (isLoading) {
    return <Loader progress={loadingProgress} />;
  }

  return (
    <div className={`transition-opacity duration-700 ${showContent ? 'opacity-100' : 'opacity-0'}`}>
      <BrowserRouter className={`bg-primary w-full overflow-hidden ${styles.paddingX} ${styles.flexCenter}`}>
        <Navbar />
        <AnimatedRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;